export type NotificationFormat = "color" | "color_text"

export interface NotificationPrefs {
    enabled: boolean
    format: NotificationFormat
}

const STORAGE_KEY = "copilot_notification_prefs"

const DEFAULT_PREFS: NotificationPrefs = {
    enabled: true,
    format: "color_text",
}

export function getNotificationPrefs(): NotificationPrefs {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return DEFAULT_PREFS
        const parsed = JSON.parse(raw) as Partial<NotificationPrefs>
        return {
            enabled: true,
            format: parsed.format === "color" ? "color" : "color_text",
        }
    } catch {
        return DEFAULT_PREFS
    }
}

export function setNotificationPrefs(prefs: NotificationPrefs): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs))
    } catch {
        // localStorage unavailable — preferences won't persist
    }
}
